'use client';

import { publicApiPath } from '@/lib/apiBase';

export type AnalyticsEvent = 'site_visit' | 'landing' | 'landing_auth';

const LANDING_FLAG = 'dl_landing_session';

function sessionDedupeKey(event: AnalyticsEvent): string {
  return `dl_analytics_${event}`;
}

export function markLandingSession(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(LANDING_FLAG, '1');
  } catch {
    /* ignore */
  }
}

export function hadLandingSession(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(LANDING_FLAG) === '1';
  } catch {
    return false;
  }
}

export function clearLandingSessionFlag(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(LANDING_FLAG);
  } catch {
    /* ignore */
  }
}

export function trackAnalyticsEvent(event: AnalyticsEvent): void {
  if (typeof window === 'undefined') return;
  try {
    const dedupe = sessionDedupeKey(event);
    if (sessionStorage.getItem(dedupe) === '1') return;
    sessionStorage.setItem(dedupe, '1');
  } catch {
    /* continue without dedupe */
  }

  void fetch(publicApiPath('/v1/api/analytics/event'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event }),
    keepalive: true,
  }).catch(() => undefined);

  if (event === 'landing') {
    markLandingSession();
  }
  if (event === 'landing_auth') {
    clearLandingSessionFlag();
  }
}

export function trackLandingAuthIfApplicable(): void {
  if (hadLandingSession()) {
    trackAnalyticsEvent('landing_auth');
  }
}
